import React from 'react'

const GoalArea = () => {
    return (
        <div className="goal-area space">
            <div className="container">
                <div className="row align-items-end">
                    <div className="col-lg-6">
                        <div className="title-area">
                            <span className="sub-title">
                                <img src="assets/img/icon/title_left.svg" alt="shape" />
                                Nossa História e Propósito
                            </span>
                            <h2 className="sec-title style2">Desenvolvendo Conexões de Valor Entre Empresas e Talentos</h2>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="goal-title-area">
                            <p className="">
                                Desde 2023, o Grupo Rocvel atua no mercado corporativo combinando inteligência estratégica e processos modernos para transformar a gestão de capital humano. Nossa atuação une proximidade, credibilidade e foco em performance para gerar resultados sustentáveis para parceiros em todo o território nacional.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="goal-tabs-wrapper">
                        <div
                            className="nav nav-tabs goal-tabs-tabs"
                            id="nav-tab"
                            role="tablist"
                        >
                            <button
                                className="nav-link"
                                id="nav-step1-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step1"
                                type="button"
                            >
                                Essência
                            </button>
                            <button
                                className="nav-link"
                                id="nav-step2-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step2"
                                type="button"
                            >
                                Estratégia
                            </button>
                            <button
                                className="nav-link active"
                                id="nav-step3-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step3"
                                type="button"
                            >
                                Qualidade
                            </button>
                            <button
                                className="nav-link"
                                id="nav-step4-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step4"
                                type="button"
                            >
                                Retenção
                            </button>
                        </div>
                        <div className="tab-content" id="nav-tabContent">
                            <div className="tab-pane fade" id="nav-step1" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Recrutamento Estratégico Especializado
                                            </h4>
                                            <p>Abordagem Altamente Consultiva</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Redução do tempo de contratação
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Assertividade nas admissões
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Foco em Qualidade e Retenção</h4>
                                            <p>Gestão de Talentos</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Forte aderência cultural
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Menor índice de turnover
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Inteligência de Mercado</h4>
                                            <p>Processos Modernos</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Mitigação de custos operacionais
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Resultados sustentáveis
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="nav-step2" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Recrutamento Estratégico Especializado
                                            </h4>
                                            <p>Abordagem Altamente Consultiva</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Redução do tempo de contratação
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Assertividade nas admissões
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Foco em Qualidade e Retenção</h4>
                                            <p>Gestão de Talentos</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Forte aderência cultural
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Menor índice de turnover
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Inteligência de Mercado</h4>
                                            <p>Processos Modernos</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Mitigação de custos operacionais
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Resultados sustentáveis
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade active show"
                                id="nav-step3"
                                role="tabpanel"
                            >
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Recrutamento Estratégico Especializado
                                            </h4>
                                            <p>Abordagem Altamente Consultiva</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Redução do tempo de contratação
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Assertividade nas admissões
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Foco em Qualidade e Retenção</h4>
                                            <p>Gestão de Talentos</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Forte aderência cultural
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Menor índice de turnover
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Inteligência de Mercado</h4>
                                            <p>Processos Modernos</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Mitigação de custos operacionais
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Resultados sustentáveis
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="nav-step4" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Recrutamento Estratégico Especializado
                                            </h4>
                                            <p>Abordagem Altamente Consultiva</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Redução do tempo de contratação
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Assertividade nas admissões
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Foco em Qualidade e Retenção</h4>
                                            <p>Gestão de Talentos</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Forte aderência cultural
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Menor índice de turnover
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Bizmaster" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Inteligência de Mercado</h4>
                                            <p>Processos Modernos</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Mitigação de custos operacionais
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Resultados sustentáveis
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GoalArea